import React from 'react';
import { TextField, Typography } from '@mui/material';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';
import FieldSettingsPanel from './FieldSettingsPanel';

export default function FieldSuggestionSettings({
  value,
  error,
  helperText,
  onChange,
}) {
  const { semantic, typographyStyles } = useFeatureTheme();

  return (
    <FieldSettingsPanel title="Suggestion message">
      <Typography
        variant="body2"
        sx={{
          ...typographyStyles.caption,
          color: semantic.text.secondary,
          mb: 1.5,
        }}
      >
        Shown to users as guidance when filling this field.
      </Typography>
      <TextField
        label="Suggestion message"
        size="small"
        fullWidth
        multiline
        minRows={2}
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        error={Boolean(error)}
        helperText={helperText || error}
        placeholder="Enter a helpful hint for this field"
      />
    </FieldSettingsPanel>
  );
}
